export default __webpack_public_path__ + "static/Card2-63a357774c2a8a329649123f2a3f2289.png";